/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedblocksignoffdaysinadvance6Inputs */

const en__field_inheritedblocksignoffdaysinadvance6 = /** @type {(inputs: _Field_Inheritedblocksignoffdaysinadvance6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signoff Block Range (inherited)`)
};

const de__field_inheritedblocksignoffdaysinadvance6 = /** @type {(inputs: _Field_Inheritedblocksignoffdaysinadvance6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmeldefrist (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "Signoff Block Range (inherited)" |
*
* @param {_Field_Inheritedblocksignoffdaysinadvance6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedblocksignoffdaysinadvance6 = /** @type {((inputs?: _Field_Inheritedblocksignoffdaysinadvance6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedblocksignoffdaysinadvance6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedblocksignoffdaysinadvance6(inputs)
	return de__field_inheritedblocksignoffdaysinadvance6(inputs)
});
export { _field_inheritedblocksignoffdaysinadvance6 as "_field_inheritedBlockSignOffDaysInAdvance" }